import {
  Modal, Typography, Form, Row, Col, Input, Button
} from "antd";
import { Trans, useTranslation } from "react-i18next";
import classes from "../PatientDashboard/onboardingModal.module.css";
import useAssistanceModal from "./useAssistanceModal";

const { TextArea } = Input;
const { Title, Text } = Typography;

const AssistanceModal = () => {
  const { t } = useTranslation();
  const {
    form,
    loading,
    handleSubmit,
    isAssistantModalOpen,
    data,
    toggleAssistModal,
  } = useAssistanceModal();

  return (
    <Modal
      open={isAssistantModalOpen}
      title={<Title level={2}>Possiamo aiutarti?<br/> Siamo qui per te</Title>}
      width={512}
      centered
      onOk={() => form.submit()}
      okButtonProps={{ loading, disabled: loading }}
      onCancel={() => toggleAssistModal()}
      footer={null}
      forceRender
    >
      <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
        <Trans
          i18nKey="dashboardPage.support.title"
          components={{
            linkWrap: <Button
              type="link"
              href="mailto:supporto@inbuonasalute.com"
              style={{ padding: 0, height: "auto" }}
            />
          }}
        />
      </Text>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        className={classes.form}
      >
        <Row gutter={[16, 16]}>
          {data.map((item) => (
            <Col span={24} sm={item.layout} key={item.name}>
              <Form.Item
                label={item.label}
                name={item.name}
                rules={item.rules}
              >
                {(() => {
                  switch (item.name) {
                    case "message":
                      return <TextArea rows={4} />;
                    default:
                      return <Input/>;
                  }
                })()}
              </Form.Item>
            </Col>
          ))}
          <Col span={24}>
            <Form.Item>
              <Button size="large" type="primary" htmlType="submit" loading={loading} disabled={loading} block>
                {t("dashboardPage.support.submitButton")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AssistanceModal;
